import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/toku_autodebit_icon.svg'
import _imports_1 from '@/assets/icons/toku_autodebit_chevron.svg'


const _hoisted_1 = { class: "toku-autodebit-banner__copy" }
const _hoisted_2 = { class: "toku-autodebit-banner__title" }
const _hoisted_3 = { class: "toku-autodebit-banner__subtitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "toku-autodebit-banner",
    "data-testid": "toku-autodebit-banner",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
  }, [
    _cache[1] || (_cache[1] = _createElementVNode("img", {
      class: "toku-autodebit-banner__icon",
      src: _imports_0,
      width: "24",
      height: "24",
      alt: "",
      "aria-hidden": "true"
    }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.t("TokuAutodebit-Banner-Title")), 1),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.t("TokuAutodebit-Banner-Subtitle")), 1)
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("div", {
      class: "toku-autodebit-banner__cta",
      "aria-hidden": "true"
    }, [
      _createElementVNode("img", {
        src: _imports_1,
        width: "12",
        height: "20",
        alt: ""
      })
    ], -1))
  ]))
}